<template>
	<div class="verify-email-component">
		<div class="verify-email-component__content">
			<h4 class="header">Meagur</h4>
			<div class="verify-email-form">
				<p>We sent a code to your email for verification. Please enter it below.</p>
				<form @submit.prevent="thisVerifyEmail">
					<div class="form-group">
						<input class="text-input font-size--medium" type="number" placeholder="Verification Code" v-model="verificationCode" id="codeInput" required>
					</div>
					<div class="form-group">
						<input class="btn btn--form-submit font-size--medium" type="submit" value="Verify Email">
					</div>
				</form>
			</div>
			<button class="resend-button">Resend Email</button>

			<i class="material-icons md-36 close-button" @click="SET_VERIFY_EMAIL(false)">close</i>
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapActions, mapGetters } from 'vuex'

	export default {
		data() {
			return {
				verificationCode: ''
			}
		},
		computed: {
			...mapGetters([
				'getVerifyEmail'
			]),
		},
		methods: {
			...mapMutations([
				'SET_VERIFY_EMAIL',
				'HTTP_FINISHED',
				'SET_SET_PASSWORD'
			]),
			...mapActions([
				'verifyEmail'
			]),
			thisVerifyEmail() {
				var data = {
					email_verification_code: this.verificationCode,
					email: this.getVerifyEmail.email,
				}
				this.verifyEmail(data).then(() => {
					this.SET_VERIFY_EMAIL({ show: false, email: null, continueToSetPassword: false})
					this.HTTP_FINISHED()
				})
			}
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../styles/components/auth/verifyEmail'
</style>